import React from 'react'
import { makeStyles, TextField } from '@material-ui/core'
import { defaultB, defaultC, negativeC } from 'asterX-UIkit/constants/colors'
import PropTypes from 'prop-types'

const useStyles = makeStyles(theme => ({
  root: {
    border: '1px solid #DCE6F3',
    borderRadius: 10,
    backgroundColor: defaultB,
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    paddingLeft: 4,
    '&:hover': {
      backgroundColor: defaultB,
      borderColor: defaultC
    },
    '&$focused': {
      backgroundColor: defaultB,
      borderColor: defaultC
    },
    '&$error': {
      backgroundColor: defaultB,
      borderColor: negativeC
    },
    '& input[type=number]': {
      '-moz-appearance': 'textfield'
    },
    '& input[type=number]::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    },
    '& input[type=number]::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    }
  },
  focused: {},
  error: {},
  inputLabel: {
    color: defaultC,
    fontWeight: 400,
    fontSize: 14,
    paddingLeft: 2,
    '&.MuiInputLabel-shrink': {
      color: defaultC,
      fontWeight: 400,
      fontSize: 12
    },
    '&.focused': {
      color: defaultC,
      fontWeight: 400,
      fontSize: 12
    }
  }
}))

const AsterTextField = ({ InputProps, ...props }) => {
  const classes = useStyles()

  return (
    <TextField
      InputLabelProps={{
        classes: {
          root: classes.inputLabel,
          focused: 'focused'
        }
      }}
      InputProps={{
        classes: {
          root: classes.root,
          error: classes.error,
          focused: classes.focused
        },
        disableUnderline: true,
        ...InputProps
      }}
      {...props}
      variant="filled"
    />
  )
}
export default AsterTextField
AsterTextField.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func,
  InputProps: PropTypes.object,
  InputLabelProps: PropTypes.object,
  required: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  type: PropTypes.string,
  style: PropTypes.object,
  name: PropTypes.string,
  id: PropTypes.string,
  fullWidth: PropTypes.bool
}
